'use strict';

var _ = require('lodash');
var PrepareInitialDataPointsService = function PrepareInitialDataPointsService(daysOfWeekHelper, seasonalityConstants) {
  function prepareInitialDataPoints(dateRangeStart, dateRangeEnd, dowGroupDefinition) {
    var firstMondayOfSecondYear = daysOfWeekHelper.getFirstDayOfDow(dateRangeEnd.year(), 'Mon');
    var week = dateRangeStart.isAfter(firstMondayOfSecondYear) ? dateRangeStart : firstMondayOfSecondYear;
    var weekNumber = seasonalityConstants.WOY_1;
    var secondYearWeeks = [];
    var firstYearWeeks = [];
    while (!week.isAfter(dateRangeEnd)) {
      if (weekNumber === seasonalityConstants.WOY_53) {
        weekNumber = seasonalityConstants.WOY_1;
      }
      var dowsInWeek = daysOfWeekHelper.daysMatchingDowGroup(week, firstMondayOfSecondYear, dateRangeEnd, dowGroupDefinition.dow);
      if (dowsInWeek.length !== 0) {
        secondYearWeeks.push(buildDataPoint(week, weekNumber, dateRangeStart, dateRangeEnd, dowGroupDefinition));
      }
      if (currentWeekIsComplete(week, dateRangeEnd)) {
        weekNumber++;
      }
      week = startsFromMonday(week) ? daysOfWeekHelper.dayOfWeekAfter(week, 'Mon') : week.add(1, 'week');
    }
    week = dateRangeStart;
    while (week.isBefore(firstMondayOfSecondYear)) {
      if (shouldResetOrdering(week, dateRangeEnd)) {
        weekNumber = seasonalityConstants.WOY_1;
      }
      if (weekContainsAtLeastOneDOW(week, dateRangeStart, dowGroupDefinition, firstMondayOfSecondYear)) {
        firstYearWeeks.push(buildDataPoint(week, weekNumber, dateRangeStart, dateRangeEnd, dowGroupDefinition));
      }
      week = startsFromMonday(week) ? daysOfWeekHelper.dayOfWeekAfter(week, 'Mon') : week.add(1, 'week');
      weekNumber++;
    }
    return firstYearWeeks.concat(secondYearWeeks);
  }
  function currentWeekIsComplete(week, end) {
    var isNotLastWeekToProcess = !week.add(1, 'week').isAfter(end);
    var isSunday = end.day() === 0;
    return isNotLastWeekToProcess || isSunday;
  }
  function startsFromMonday(week) {
    return week.day() !== 1;
  }
  function shouldResetOrdering(week, end) {
    var nextWeekToProcess = week.add(1, 'week');
    var isLastWeekInDateRange = nextWeekToProcess.isAfter(end);
    var weekContainsLastDayOfTheYear = week.year() !== nextWeekToProcess.year();
    var dateRangeEndIsNotSunday = end.day() !== 0;
    return isLastWeekInDateRange && weekContainsLastDayOfTheYear && dateRangeEndIsNotSunday;
  }
  function weekContainsAtLeastOneDOW(week, dateRangeStart, dowGroupDefinition, firstMondayOfSecondYear) {
    if (week.isSame(dateRangeStart)) {
      var endOfTheWeek = daysOfWeekHelper.dayOfWeekAfter(week, 'Sun');
      return daysOfWeekHelper.daysMatchingDowGroup(week, dateRangeStart, endOfTheWeek, dowGroupDefinition.dow).length !== 0;
    } else {
      return daysOfWeekHelper.daysMatchingDowGroup(week, dateRangeStart, firstMondayOfSecondYear, dowGroupDefinition.dow).length !== 0;
    }
  }
  function buildDataPoint(week, weekNumber, dateRangeStart, dateRangeEnd, dowGroupDefinition) {
    return {
      date: week,
      weekNumber: weekNumber,
      firstDayOfDowGroup: _.first(daysOfWeekHelper.daysMatchingDowGroup(week, dateRangeStart, dateRangeEnd, dowGroupDefinition.dow))
    };
  }
  return {
    prepareInitialDataPoints: prepareInitialDataPoints
  };
};
PrepareInitialDataPointsService.$inject = ['DaysOfWeekHelper', 'SeasonalityConstants'];
module.exports = PrepareInitialDataPointsService;